module.exports = __webpack_public_path__ + "static/media/programme_slogan_sr.41396617.png";